module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_studio-photo-7ab16fa907725cdee8c22514cb7d7d65.jpg";